export class BuilderMenuCtrl {
  constructor(TemplateService, EventService) {
    'ngInject';
    this.ts = TemplateService;
    this.es = EventService;
  }

  async $onInit() {
    this.td = await this.ts.getTemplateData();

    this.td && this.ts.subscribeUpdate(options => {
      this.ts.updateTemplateData(this.td, options);
    }, 'TEMPLATE_DATA_UPDATED_BUILDER_MENU');
  }

  changeTemplateProp(prop) {
    this.ts.notifyUpdate([prop], this.td);
  }

  hasUnsavedChanges() {
    return this.td && this.ts.templateHasChanges(this.td?.template);
  }

  mouseEntered() {
    this.es.dispatchEvent(
      this.es.actions.MOUSE_ENTERED_BUILD_HEADER, null);
  }
}

export default {
  bindings: {
    openTemplateOptions: "&",
    isSaveDisabled: "&",
    saveChanges: "&",
    saveChangesAs: "&",
    discardChanges: "&",
    validationState: "=",
    loading: "="
  },
  controller: BuilderMenuCtrl,
  templateUrl: 'form-builder/builder-menu/builder-menu.component.html',
}